import createValidationFn from '@gef-ui/form-core/validations/createValidationFn';
import { onlyAllowedCharsDisjoint } from '@gef-ui/form-core/validations/validationFunctions/text';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { dayMonthsAcceptedFormats, regexDate } from '../constants';
import { isDateWithOrder, isLength } from './common';

const minLength = isLength({
	minLength: 4,
	maxLength: 5,
	minLengthMessageKey: 'validation:lengthBetweenScope',
});

const allowedChars = onlyAllowedCharsDisjoint({
	regex: new RegExp(regexDate),
	messageKey: 'validation:allowedCharactersDate',
});

const acceptedDateFormats = (fieldValue) => {
	return new RegExp(dayMonthsAcceptedFormats).test(fieldValue)
		? false
		: getLabelMessage('validation:wrongFormatWithExample');
};

export default createValidationFn(({ fromFieldName, toFieldName }) => (args) => {
	const { fieldValue } = args;
	if (!fieldValue) {
		return null;
	}

	const dateOrder = isDateWithOrder({ fromFieldName, toFieldName, type: 'dateLikeString' });

	return (
		minLength.validate(args)?.errorMessage ||
		allowedChars.validate(args)?.errorMessage ||
		acceptedDateFormats(fieldValue) ||
		dateOrder.validate(args)?.errorMessage
	);
});
